import { CustomModal } from "components/CustomModal";
import { IfcPipelineJob } from "features/dt-plus-setup/model/types";

import { ExecutionStepsContent } from "./ExecutionStepsContent";

type ExecutionStepsModalProps = {
  onClose: () => void;
  selectedJob: IfcPipelineJob | undefined;
};

export const ExecutionStepsModal = ({ onClose, selectedJob }: ExecutionStepsModalProps) => {
  const open = !!selectedJob;

  return (
    <CustomModal
      className="overflow-auto"
      height="95vh"
      modalOpen={open}
      padding="2rem"
      setModalOpen={(value: boolean) => {
        if (!value) onClose();
      }}
      width="72rem"
    >
      <ExecutionStepsContent
        completedAt={selectedJob?.completed_at}
        createdAt={selectedJob?.created_at}
        errorMessage={selectedJob?.error_msg ?? undefined}
        infoMessage={selectedJob?.message ?? undefined}
        progressPercent={selectedJob?.progress_percent}
        scheduleProgress={selectedJob?.schedule_progress}
        status={selectedJob?.status}
        steps={selectedJob?.steps}
      />
    </CustomModal>
  );
};
